import ServicePageTemplate from '../services/ServicePageTemplate';
import { seoPageData } from '../../mocks/seoPages';
const AcInstallationPage = () => <ServicePageTemplate data={seoPageData['ac-installation']} />;
export default AcInstallationPage;
